import { render } from "./details.vue?vue&type=template&id=eccb2188"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"

import "./details.vue?vue&type=style&index=0&id=eccb2188&lang=css"

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/components/pages/courses/details.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "eccb2188"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('eccb2188', __exports__)) {
    api.reload('eccb2188', __exports__)
  }
  
  module.hot.accept("./details.vue?vue&type=template&id=eccb2188", () => {
    api.rerender('eccb2188', render)
  })

}


export default __exports__